module.exports = __webpack_public_path__ + "static/media/02(1).7ed78ba6.jpg";